import { HttpClient, serializeJSONApiData } from '@opallabs/api'
import { track } from '@opallabs/quanta'
import { registerAction } from '../../Action'

const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION'
const sendUpdate = (id, data) => {
  HttpClient().patch(`/api/v1/notifications/${id}`, { data })
}

const trackNotificationClick = (notification) => {
  let notificationStatus = 'Unseen'

  if (notification.seen && !notification.read) {
    notificationStatus = 'seen'
  } else if (notification.read) {
    notificationStatus = 'read'
  }

  const notificationType =
    notification.type === 'download' ? 'Downloads' : 'Notification'

  track(`Personal Panel: ${notificationType} Click`, {
    'Notification Id': notification.id,
    'Notification Type': notification.type,
    'Notification Status': notificationStatus,
  })
}

const reducer = (state = {}, action) => {
  trackNotificationClick(action.payload)

  const notificationId = action.payload.id
  const params = serializeJSONApiData('notifications', action.payload)
  sendUpdate(notificationId, params.data)

  return state
}

const updatedNotifications = registerAction(UPDATE_NOTIFICATION, { reducer })

export default updatedNotifications
